import React from 'react'
import { Navigate } from 'react-router-dom'

import { DashboardRoutes as dashboardRoutes } from '../pages/Dashboard'
import themeExamplesRoutes from '../pages/ThemeComponentsexamples/ThemeExamplesRoutes'
import InsidentsRoutes from 'pages/Insidents/InsidentsRoutes'
import DataSetupRoutes from 'pages/DataSetups/DataSetupRoutes'
import RiskAssessmentRoutes from 'pages/RiskAssessment/RiskAssessmentRoutes'
import AuditsRoutes from 'pages/Audits/AuditsRoutes'
import TrainingRoutes from 'pages/Training/TrainingRoutes'
const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Navigate to="/login" />,
    },
]

const errorRoute = [
    {
        component: () => <Navigate to="/session/404" replace />,
    },
]

const routes = [
    ...redirectRoute,
    ...dashboardRoutes,
    ...themeExamplesRoutes,
    ...errorRoute,
    ...InsidentsRoutes,
    ...RiskAssessmentRoutes,
    ...DataSetupRoutes,
    ...TrainingRoutes,
    ...AuditsRoutes,
    { path: '*', component: () => <Navigate to="/session/404" replace /> },
]

export default routes